<div class="header content-card">
  <h2>{{ 'Subordinates' | translate }}</h2>
</div>

<div class="table-wrapper custom-table">
  <!-- Subordinates' Table -->
  <mat-table
    #table
    matSort
    matSortActive="endDate"
    matSortDirection="desc"
    matSortDisableClear
    [dataSource]="dataSource.subordinates$ | async"
    multiTemplateDataRows
    class="main-table">
    <!-- Expand Column -->
    <ng-container matColumnDef="expandingIcon">
      <mat-header-cell *matHeaderCellDef class="expand-header"></mat-header-cell>
      <mat-cell
        class="expand-cell"
        *matCellDef="let element"
        (click)="expandRow(expandedElementUserId, element.Id)"
        >
        @if (element[expansionDataName] && element[expansionDataName].length > 0) {
          <mat-icon>
            {{ expandedElementUserId !== element.Id	? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </mat-icon>
        }
      </mat-cell>
    </ng-container>

    <!-- WorkerFullName Column -->
    <ng-container matColumnDef="workerFullName">
      <mat-header-cell mat-sort-header="LastName" *matHeaderCellDef class="hidden-sort"> {{ 'WorkerFullName' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <a [routerLink]="['/profile', element.WorkerId, 'contactInfo']">{{ element.LastName }} {{ element.FirstName }}</a>
      </mat-cell>
    </ng-container>

    <!-- Start Date Column -->
    <ng-container matColumnDef="startDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort"> {{ 'SubordinatesFrom' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.StartDate | date: 'yyyy-MM-dd' }}</mat-cell>
    </ng-container>

    <!-- End Date Column -->
    <ng-container matColumnDef="endDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort"> {{ 'SubordinatesTo' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.EndDate | date: 'yyyy-MM-dd' }}</mat-cell>
    </ng-container>

    <!-- Supervisor Type Column -->
    <ng-container matColumnDef="supervisorTypeId">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort"> {{ 'Subordinate' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.SupervisorTypeId | translateSupervisorType }}</mat-cell>
    </ng-container>

    <!-- Expanded Content Column -->
    <ng-container matColumnDef="expandedDetail">
      <mat-cell *matCellDef="let element" [attr.colspan]="columns.length">
        <div class="expanded-element-detail" [@detailExpand]="element.Id == expandedElementUserId ? 'expanded' : 'collapsed'">
          <mat-table #table [dataSource]="element[expansionDataName]" class="secondary-table">

            <!-- WorkerFullName Column -->
            <ng-container matColumnDef="workerFullName">
              <mat-cell *matCellDef="let element">
                <a [routerLink]="['/profile', element.WorkerId, 'contactInfo']">{{ element.LastName }} {{ element.FirstName }}</a>
              </mat-cell>
            </ng-container>

            <!-- StartDate Column -->
            <ng-container matColumnDef="startDate">
              <mat-header-cell *matHeaderCellDef> {{ 'StartDate' | translate }} </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.StartDate | date: 'yyyy-MM-dd' }}</mat-cell>
            </ng-container>

            <!-- EndDate Column -->
            <ng-container matColumnDef="endDate">
              <mat-header-cell *matHeaderCellDef> {{ 'EndDate' | translate }} </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.EndDate | date: 'yyyy-MM-dd' }}</mat-cell>
            </ng-container>

            <!-- Supervisor Type Column -->
            <ng-container matColumnDef="supervisorTypeId">
              <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Subordinate' | translate }} </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.SupervisorTypeId | translateSupervisorType }}</mat-cell>
            </ng-container>

            <mat-row *matRowDef="let row; columns: displayedExpandedColumns"></mat-row>
          </mat-table>
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row
      *matRowDef="let element; columns: columns"
      class="expanded-element-row"
      [class.expanded-row]="expandedElementUserId === element.Id"
    ></mat-row>
    <mat-row
      [@rowExpand]="row.Id == expandedElementUserId ? 'expanded' : 'collapsed'"
      *matRowDef="let row; columns: ['expandedDetail']"
    class="expanded-detail-row"></mat-row>
  </mat-table>
</div>

<mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"> </mat-paginator>
